import { render, staticRenderFns } from "./CommissionsNews.vue?vue&type=template&id=0373b7ab&"
import script from "./CommissionsNews.vue?vue&type=script&lang=js&"
export * from "./CommissionsNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports